export default __webpack_public_path__ + "static/media/marcela-laskoski-YrtFlrLo2DQ-unsplash-1.1ecf8157.jpg";